/**
 * @generated SignedSource<<66c234f1abe6edf2bf28156d9c9c5522>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type url_issueFieldUrlReadviewFull_UrlReadView$data = {
  readonly id?: string;
  readonly uri: string | null | undefined;
  readonly " $fragmentType": "url_issueFieldUrlReadviewFull_UrlReadView";
};
export type url_issueFieldUrlReadviewFull_UrlReadView$key = {
  readonly " $data"?: url_issueFieldUrlReadviewFull_UrlReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"url_issueFieldUrlReadviewFull_UrlReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "url_issueFieldUrlReadviewFull_UrlReadView",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "uri"
    }
  ],
  "type": "JiraUrlField"
};

(node as any).hash = "fdbb3125f2c4058bcc235ec607d8d838";

export default node;
